import React, { useEffect, useState } from 'react';
import { translate } from '../../services/translate';
import { deacService } from '../../services/central-api/deac';
import ExternalSelect from '../ExternalSelect';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

interface Props {
    value: number[];
    setValue: React.Dispatch<React.SetStateAction<number[]>>;
    actingBodyId?: number;
    zIndex: number;
}

function RolesDropdown({ value, setValue, zIndex, actingBodyId }: Props) {
    const { styles, theme } = useStyles(styleSheet);
    const [selectableRoles, setSelectableRoles] = useState<{ label: string; value: number; }[]>([]);

    async function loadRoles(actingBodyId: number) {
        try {
            const roles = await deacService.getRolesSimplified(actingBodyId);
            setSelectableRoles(roles.map((role) => {
                return {
                    value: role.id,
                    label: role.name,
                    color: theme.colors.backgrounds['BG-4'] // BG-4
                };
            }));
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        if (actingBodyId && actingBodyId > 0) {
            loadRoles(actingBodyId);
        }
    }, [actingBodyId]);

    return (
        <ExternalSelect
            label={translate('associatedRole')}
            labelStyle={styles.inputLabelStyle}
            items={selectableRoles}
            multiple={true}
            setValue={setValue}
            value={value}
            zIndex={zIndex}
            selectedLabel={translate('selectedRoles')}
            onRemove={(items) => setValue(items as number[])}
            initialSelectedItems={selectableRoles.filter(item => value.includes(item.value))}
            badgeTextColor={theme.colors.primary['500']}
            hintText={translate('associatedRoleHintText')}
        />
    );
}

const styleSheet = createStyleSheet((theme) => ({
    inputLabelStyle: {
        fontSize: 14,
        fontWeight: '600',
        flexWrap: 'wrap',
        color: theme.colors.modal.header,
        marginBottom: 8,
    },
}));

export default RolesDropdown;
